export enum ElevationTypeEnum {
    Unknown,
    gtopo30,
    astergdem,
    srtm1,
    srtm3,
}